"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmail = isValidEmail;
exports.isValidMobileLandNumber = isValidMobileLandNumber;
exports.isValidMobileNumber = isValidMobileNumber;
exports.isValidAlphaWithSpace = isValidAlphaWithSpace;
exports.isValidAlphaNumericNoSpace = isValidAlphaNumericNoSpace;
exports.isValidNric = isValidNric;

function isValidEmail(email) {
  var exp = /^([a-z0-9_\-.+]{2,100})@([a-z0-9\-.]{2,})\.([a-z0-9]{2,})$/i;
  return exp.test(email);
}

function isValidMobileLandNumber(phone) {
  var exp = /^[689][0-9]{7}$/;
  return exp.test(phone);
}

function isValidMobileNumber(phone) {
  var exp = /^[89][0-9]{7}$/;
  return exp.test(phone);
}

function isValidAlphaWithSpace(str) {
  return /^[a-zA-Z\s]+$/.test(str);
}

function isValidAlphaNumericNoSpace(str) {
  return /^[a-z0-9]+$/i.test(str);
}

function isValidNric(str) {
  if (str.length !== 9) {
    return false;
  }

  str = str.toUpperCase();
  var icArray = [];

  for (var i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] = parseInt(icArray[1], 10) * 2;
  icArray[2] = parseInt(icArray[2], 10) * 7;
  icArray[3] = parseInt(icArray[3], 10) * 6;
  icArray[4] = parseInt(icArray[4], 10) * 5;
  icArray[5] = parseInt(icArray[5], 10) * 4;
  icArray[6] = parseInt(icArray[6], 10) * 3;
  icArray[7] = parseInt(icArray[7], 10) * 2;
  var weight = 0;

  for (i = 1; i < 8; i++) {
    weight += parseInt(icArray[i], 10);
  }

  var icStartsWithM = icArray[0] === 'M';
  var offset = icArray[0] === 'T' || icArray[0] === 'G' ? 4 : icStartsWithM ? 3 : 0;
  var temp = (offset + weight) % 11;
  var st = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'];
  var fgm = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', icStartsWithM ? 'J' : 'M', 'L', 'K'];
  var theAlpha;

  if (icArray[0] === 'S' || icArray[0] === 'T') {
    theAlpha = st[temp];
  } else if (icArray[0] === 'F' || icArray[0] === 'G' || icStartsWithM) {
    theAlpha = fgm[temp];
  }

  return icArray[8] === theAlpha;
}